import { appEnv, isDevelopment } from './EnvManager';

export const SESSION_COOKIE_NAME = `umode_session_${appEnv}`;

const SHARED_DOMAIN = '.umode.app';

class CookieManager {
  set(name: string, value: string, expiresInSeconds = 30 * 24 * 60 * 60) {
    const expires = new Date(Date.now() + expiresInSeconds * 1000).toUTCString();
    let cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    if (!isDevelopment) cookie += '; Secure';
    document.cookie = cookie;
  }

  setShared(name: string, value: string, expiresInSeconds = 30 * 24 * 60 * 60) {
    const expires = new Date(Date.now() + expiresInSeconds * 1000).toUTCString();
    let cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    if (!isDevelopment) {
      cookie += `; domain=${SHARED_DOMAIN}; Secure`;
    }
    document.cookie = cookie;
  }

  get(name: string): string | null {
    const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
    if (!match) return null;
    return decodeURIComponent(match.split('=')[1] ?? '');
  }

  delete(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
  }

  /**
   * Clears a cookie set via `setShared` — it must repeat the same `domain` to
   * match, otherwise the shared `.umode.app` cookie survives and silently
   * re-authenticates the user on the next visit. In dev the cookie is host-only,
   * so no domain is needed.
   */
  deleteShared(name: string) {
    let cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
    if (!isDevelopment) {
      cookie += `; domain=${SHARED_DOMAIN}`;
    }
    document.cookie = cookie;
  }
}

export const cookieManager = new CookieManager();
